import { BodyScrollOptions, ScrollLock } from './types';

/**
 * This file contains the implementation of the active locks management.
 *
 * Whenever you lock the body scrolling, each time it is added to the active locks array.
 * Accidentally, or intentionally, you can lock the body scrolling multiple times.
 * This mechanism prevents from leaving the body scrolling locked when you unlock it.
 */

let activeLocks: ScrollLock[] = [];

export const getActiveLocks = (): ScrollLock[] => {
    return activeLocks;
};

export const setActiveLocks = (locks: ScrollLock[]): void => {
    activeLocks = locks;
};

export const hasLock = (targetElement: HTMLElement): boolean => {
    return getActiveLocks().some((lock) => lock.targetElement === targetElement);
};

export const addLock = (targetElement: HTMLElement, options: BodyScrollOptions = {}): void => {
    if (hasLock(targetElement)) return;
    setActiveLocks([...getActiveLocks(), { targetElement, options }]);
};

export const removeLock = (targetElement: HTMLElement): void => {
    setActiveLocks(getActiveLocks().filter((lock) => lock.targetElement !== targetElement));
};
